function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Formik } from 'formik';
import { Container, Spinner, Button } from 'reactstrap';
import notifications from "../../services/notifications";
import object from "../../services/utils/object";
import getResource from "../../services/resources";
import Icon from "../common/icon";
import Context from "../../services/context";
import { t } from "../../services/translator";
import FormResource from "./form/resource-form-content";

var Form = /*#__PURE__*/function (_Component) {
  _inherits(Form, _Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      submitting: false,
      data: {}
    });

    _this.state.data = props.initialValues || {};
    _this.resource = getResource(props.resource);
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Initialize form context (validation & existing data)
   */


  _createClass(Form, [{
    key: "method",
    get:
    /**
     * Get method to use for api calls
     * Depend of context
     *
     * @return {string}
     */
    function get() {
      return this.id !== undefined ? 'put' : 'post';
    }
    /**
     * Get crud method name
     *
     * @return {string}
     */

  }, {
    key: "crudMethod",
    get: function get() {
      return this.method === 'put' ? 'update' : 'create';
    }
    /**
     * Get current id
     *
     * @return {number|string}
     */

  }, {
    key: "id",
    get: function get() {
      return this.props.id;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Get mapping to build validation rules
      this.resource.fetchMapping(this.crudMethod, this.method, this.id).then(function () {
        return _this2.fetch();
      });
    }
    /**
     * Fetch data in api for update actions
     *
     * @return {Promise}
     */

  }, {
    key: "fetch",
    value: function fetch(formik) {
      var _this3 = this;

      var resource = this.resource;
      var initialValues = this.props.initialValues; // Create context

      if (this.id === undefined) {
        this.setState({
          loading: false,
          data: object.merge(resource.getMapping(this.crudMethod).getDefaultValues(), initialValues || {})
        });
        return Promise.resolve();
      } // Update context


      return this.resource.read(this.id).then(function (data) {
        _this3.setState({
          loading: false,
          data: object.merge(initialValues || {}, data)
        }, function () {
          if (formik) {
            formik.setValues(_objectSpread(_objectSpread({}, formik.values), data));
          }
        });
      }).catch(function () {
        _this3.setState({
          loading: false
        });
      });
    }
    /**
     * Submit form values to api
     * If errors are returned, they will be set in formik context
     *
     * @param {object} values
     * @param {object} formik
     */

  }, {
    key: "submit",
    value: function submit(values, formik) {
      var _this4 = this;

      this.setState({
        submitting: true
      }, function () {
        // Submit form with method expected
        _this4.resource[_this4.crudMethod](values).then(function (data) {
          _this4.setState({
            submitting: false,
            data: data
          }, function () {
            notifications.success(t('saved'), t('form_saved'));
            formik.setValues(_objectSpread(_objectSpread({}, values), data));
            var onSuccess = _this4.props.onSuccess;

            if (typeof onSuccess === 'function') {
              return onSuccess(data);
            }

            var router = _this4.props.router;

            if (_this4.id === undefined && router && router.navigateToResource && _this4.resource.canUpdate()) {
              router.navigateToResource(_this4.resource.alias, 'update', {
                id: data.id
              });
            }
          });
        }).catch(function (_ref) {
          var response = _ref.response;

          if (response && response.status === 400) {
            _this4.handleViolations(response.data.violations || [], formik);
          }

          notifications.danger(t('error'), t('something went wrong'));

          _this4.setState({
            submitting: false
          });
        });
      });
    }
    /**
     * Set form error with violations returned from api
     *
     * @param {object[]} violations
     * @param {object}   formik
     */

  }, {
    key: "handleViolations",
    value: function handleViolations() {
      var violations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var formik = arguments.length > 1 ? arguments[1] : undefined;
      notifications.error(t('oops'), t('form_has_error'));

      for (var i = 0, len = violations.length; i < len; ++i) {
        formik.setFieldError(violations[i].propertyPath, violations[i].message);
      }
    }
    /**
     * Run deletion of item
     */

  }, {
    key: "handleDelete",
    value: function handleDelete(routeNameOrPath) {
      var _this5 = this;

      this.context.confirm( /*#__PURE__*/React.createElement("div", null, t('confirm_delete'), ": ", this.id), function () {
        _this5.setState({
          loading: true
        }, function () {
          _this5.resource.delete(_this5.id).then(function () {
            var router = _this5.props.router;

            if (router && router.navigate) {
              router.navigate(routeNameOrPath || '/');
            }
          });
        });
      });
    }
    /**
     * Render submit button
     *
     * @return {JSX.Element}
     */

  }, {
    key: "renderSubmit",
    value: function renderSubmit() {
      var submitting = this.state.submitting;
      return /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        color: "info",
        size: "md",
        disabled: submitting
      }, submitting ? /*#__PURE__*/React.createElement(Spinner, {
        size: "sm",
        className: "mr-2"
      }) : /*#__PURE__*/React.createElement(Icon, {
        name: "check",
        className: "mr-2"
      }), t('submit'));
    }
    /**
     * Render submit button
     *
     * @return {JSX.Element}
     */

  }, {
    key: "renderBackToList",
    value: function renderBackToList(routeNameOrPath) {
      if (!this.resource.canReadList()) {
        return null;
      }

      var router = this.props.router;

      if (!router) {
        return null;
      }

      var onClick = function onClick() {
        return router && router.navigate(routeNameOrPath || '/');
      };

      return /*#__PURE__*/React.createElement(Button, {
        size: "md",
        color: "light",
        onClick: onClick
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "chevron-left",
        className: "mr-2"
      }), t('back_to_list'));
    }
    /**
     * Build form action bar
     *
     * @param {?JSX.Element} actions
     *
     * @return {JSX.Element}
     */

  }, {
    key: "renderActions",
    value: function renderActions(actions) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderSubmit(), actions, this.id && this.resource.canDelete() && /*#__PURE__*/React.createElement(Button, {
        size: "md",
        color: "danger",
        disabled: this.state.submitting,
        onClick: this.handleDelete
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "trash-alt",
        className: "mr-2"
      }), " ", t('delete')), this.resource.canReadList() && this.renderBackToList());
    }
    /**
     * @return {JSX.Element}
     */

  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Container, {
          className: "text-center mt-4",
          fluid: true
        }, /*#__PURE__*/React.createElement(Spinner, {
          style: {
            width: '4rem',
            height: '4rem'
          },
          color: "secondary"
        }));
      }

      var _this$state = this.state,
          submitting = _this$state.submitting,
          data = _this$state.data;
      var _this$props = this.props,
          children = _this$props.children,
          validate = _this$props.validate;
      children = Array.isArray(children) ? children : [children]; // First child has to be the form content
      // Other child will be append after form

      var _children = children,
          _children2 = _toArray(_children),
          FormContent = _children2[0],
          subChildren = _children2.slice(1);

      var mapping = this.resource.getMapping(this.crudMethod);
      return /*#__PURE__*/React.createElement(Formik, {
        initialValues: data,
        onSubmit: this.submit,
        validationSchema: mapping.rules,
        validate: validate
      }, function (formik) {
        return /*#__PURE__*/React.createElement(FormResource, {
          mapping: mapping,
          resource: _this6.resource,
          formContent: FormContent,
          formik: formik,
          subChildren: subChildren,
          submitting: submitting,
          setSubmitting: function setSubmitting(submitting) {
            return _this6.setState({
              submitting: submitting
            });
          },
          fetch: _this6.fetch.bind(_this6),
          renderSubmit: _this6.renderSubmit.bind(_this6),
          renderBackToList: _this6.renderBackToList.bind(_this6),
          renderActions: _this6.renderActions.bind(_this6)
        });
      });
    }
  }]);

  return Form;
}(Component);

_defineProperty(Form, "contextType", Context);

export { Form as default };